import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Sparkles, Gift, Bell, Star } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CATEGORY_META = {
  update:   { label: 'Update',  color: 'bg-blue-100 text-blue-800',       icon: Sparkles },
  offer:    { label: 'Offer',   color: 'bg-emerald-100 text-emerald-800', icon: Gift },
  reminder: { label: 'Reminder',color: 'bg-amber-100 text-amber-800',     icon: Bell },
  feature:  { label: 'Feature', color: 'bg-purple-100 text-purple-800',   icon: Star },
};

const Announcements = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/announcements`, { withCredentials: true });
      setItems(data || []);
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to load announcements'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (a) => {
    if (a.read) return;
    try {
      await axios.post(`${API}/announcements/${a.announcement_id}/mark-read`, {}, { withCredentials: true });
      setItems(items.map(x => x.announcement_id === a.announcement_id ? { ...x, read: true } : x));
    } catch { /* silent */ }
  };

  if (loading) return <div className="flex items-center justify-center h-96"><div className="spinner" /></div>;

  return (
    <div className="space-y-6" data-testid="announcements-page">
      <div>
        <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: 'Manrope' }}>Announcements</h1>
        <p className="text-slate-600 mt-1 text-sm">Platform updates, offers and reminders from the InsureGrowth team.</p>
      </div>

      {items.length === 0 ? (
        <Card className="border-slate-200"><CardContent className="py-12 text-center text-slate-500" data-testid="announcements-empty">
          No announcements yet. Check back soon.
        </CardContent></Card>
      ) : (
        <div className="space-y-3">
          {items.map((a) => {
            const meta = CATEGORY_META[a.category] || CATEGORY_META.update;
            const Icon = meta.icon;
            return (
              <Card key={a.announcement_id} className={`border-slate-200 ${!a.read ? 'ring-1 ring-blue-200' : ''}`} data-testid={`announce-row-${a.announcement_id}`} onClick={() => markRead(a)}>
                <CardHeader className="pb-2 flex flex-row items-start gap-3">
                  <div className={`h-9 w-9 rounded-lg flex items-center justify-center ${meta.color}`}><Icon className="h-4 w-4" /></div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <CardTitle className="text-base" style={{ fontFamily: 'Manrope' }}>{a.title}</CardTitle>
                      <Badge className={meta.color}>{meta.label}</Badge>
                      {!a.read && <Badge className="bg-blue-600 text-white text-[10px]">NEW</Badge>}
                    </div>
                    <p className="text-xs text-slate-500 mt-0.5">{new Date(a.created_at).toLocaleString('en-IN')} · by {a.author_name || 'InsureGrowth'}</p>
                  </div>
                </CardHeader>
                <CardContent><p className="text-sm text-slate-700 whitespace-pre-line">{a.body}</p></CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Announcements;
